export const PremiumPartner = () => {
    return null;
    return (
        <a href="https://lf-group.com" target="_blank" rel="noreferrer noopener">
            <img src="https://fcrodina.com/partners/a35b82be9fbb7bb1236ad85969b83d99.png" alt="LF Group ." className="h-8" />
        </a>
    );
}